export default __webpack_public_path__ + "static/media/icon-gg.52a1b56b.svg";